<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"> </v-col>
      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-16" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ formCompData.title }}</span>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="formComp.eventForm"
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="grey" outlined @click="closeform">{{
              $t("general.back")
            }}</v-btn>
            <v-btn color="primary" @click="saveForm(false)" data-cy="saveEvent">
              <div
                v-if="
                  $route.params.mode === 'new' || $route.params.mode === 'copy'
                "
              >
                {{ $t("general.save") }}
              </div>
              <div v-if="$route.params.mode === 'edit'">
                {{ $t("general.saveChanges") }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="2"> </v-col>
    </v-row>
  </div>
</template>

<script>
function getDefaultData() {
  return {
    name: "",
    date: new Date(),
    employeeName: "",
    description: "",
    incidentReportType: "quick",
  };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../components/api/api";
import i18n from "../../i18n";
export default {
  components: { formComponent },
  props: ["data"],
  data: function () {
    return {
      formCompData: {
        title: "incidentReports.createIncidentReports",
        item: null,
      },
      formComp: {
        eventForm: getDefaultData(),
        form: [
          [
            {
              cols: 12,
              sm: 8,
              md: 8,
              class: "pb-0 pt-0",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "name",
                label: i18n.t("incidentReports.fields.title"),
                dataCy: "name",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
            {
              cols: 12,
              sm: 4,
              md: 4,
              class: "pb-0 pt-0",
              id: getUniqueId(),
              componentName: "incidentReportDate",
              config: {},
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0 pt-3",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "employeeName",
                label: i18n.t("incidentReports.fields.employeeName"),
                dataCy: "employeeName",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0",
              id: getUniqueId(),
              componentName: "vTextarea",
              config: {
                vModel: "description",
                label: i18n.t("incidentReports.fields.incidentCourse"),
                dataCy: "description",
                rules: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
              },
            },
          ],
        ],
      },
    };
  },
  mounted() {
    this.switchFormModes(this.$route.params.mode, this.$route.params);
  },
  methods: {
    switchFormModes(mode, params) {
      this.formCompData.title = this.$t("incidentReports.nearMissTitle");
      switch (mode) {
        case "edit":
          this.$store
            .dispatch("getSingleIncidentReport", params.id)
            .then((item) => {
              this.formComp.eventForm = item;
            });
          break;
        case "copy": {
          this.$store
            .dispatch("getSingleIncidentReport", params.id)
            .then((item) => {
              this.formComp.eventForm = item;
              //delete individual data
              delete this.formComp.eventForm._id;
              delete this.formComp.eventForm.id;
              delete this.formComp.eventForm.createdAt;
              delete this.formComp.eventForm.createdBy;
              delete this.formComp.eventForm.updatedAt;
            });
          break;
        }
        case "new":
          break;
      }
    },
    closeform() {
      this.resetData("new");
    },
    saveForm(createNew) {
      if (this.$refs.formComponent.validateAllFields()) {
        if (
          this.$route.params.mode === "new" ||
          this.$route.params.mode === "copy"
        ) {
          //create new item
          this.$store
            .dispatch("createIncidentReport", this.formComp.eventForm)
            .then((val) => {
              this.afterUpdateCheck(val, createNew, "new");
            });
        } else {
          //edit item
          this.$store
            .dispatch("updateIncidentReport", this.formComp.eventForm)
            .then((val) => {
              this.afterUpdateCheck(val, createNew, "edit");
            });
        }
      }
    },
    afterUpdateCheck(val, createNew, mode) {
      if (createNew) {
        this.resetData(mode);
        return;
      }

      if (this.goToRecordFolder(val)) return;

      this.closeform();
    },
    goToRecordFolder(val) {
      const date = val && val.date ? new Date(val.date) : null;
      if (!date || Number.isNaN(date.getTime())) return false;

      const year = String(date.getFullYear());
      const month = String(date.getMonth() + 1);
      const from = this.$route.query;

      if (String(from.year) === year && String(from.month) === month) {
        return false;
      }

      this.reloadData();
      this.$router.push({
        name: "incidentReportByMonth",
        params: { year, month },
      });
      return true;
    },

    resetData(mode) {
      this.formComp.eventForm = getDefaultData();
      if (mode === "new") {
        this.$refs.formComponent.resetForm();
      }
      this.reloadData();
      this.$router.back();
    },
    reloadData() {
      this.$emit("reloadData");
    },
  },
};
</script>
